(function(){
function init(){
  var root=document.getElementById('ShRoot'); if(!root||root.dataset.ready) return; root.dataset.ready='1';
  var $=function(s){return document.querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var portal=document.getElementById('ShPortal');
  $$('body > .sh-portal').forEach(function(p){if(p!==portal)p.remove()});
  if(portal&&portal.parentNode!==document.body)document.body.appendChild(portal);
  var hover=window.matchMedia('(hover:hover)'), desk=window.matchMedia('(min-width:1000px)');
  var hdr=$('#ShHdr'), scrim=$('#ShScrim'), search=$('#ShSearch'), drawerEl=$('#ShDrawer'), dscrim=$('#ShDscrim');
  var drops={shop:{btn:$('[data-sh-shop]'),el:$('#ShDrop')},svc:{btn:$('[data-sh-svc]'),el:$('#ShDropSvc')}};
  var t=null;

  var onScroll=function(){root.classList.toggle('is-scrolled',window.scrollY>4)}; onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  function panel(name){
    Object.keys(drops).forEach(function(k){var d=drops[k];if(!d.btn||!d.el)return;var on=name===k;
      d.el.classList.toggle('is-show',on);d.btn.classList.toggle('is-open',on);d.btn.setAttribute('aria-expanded',on);});
    var srch=name==='search', was=isOpen(search);
    search.classList.toggle('is-show',srch); $$('[data-sh-search]').forEach(function(b){b.setAttribute('aria-expanded',srch)});
    scrim.classList.toggle('is-show',!!name);
    if(srch){var qi=$('#ShQ');try{qi.focus({preventScroll:true})}catch(e){qi.focus()}if(document.activeElement!==qi)setTimeout(function(){qi.focus()},60)}
    else if(was&&search.contains(document.activeElement)&&searchBtn)searchBtn.focus({preventScroll:true});
  }
  var searchBtn=null;
  var isOpen=function(el){return !!el&&el.classList.contains('is-show')};
  var anyDrop=function(){return isOpen(drops.shop.el)||isOpen(drops.svc.el)};
  Object.keys(drops).forEach(function(k){var d=drops[k];if(!d.btn||!d.el)return;
    d.btn.addEventListener('click',function(){panel(isOpen(d.el)?null:k)});
    d.btn.addEventListener('mouseenter',function(){if(!hover.matches)return;clearTimeout(t);t=setTimeout(function(){panel(k)},80)});
    d.btn.addEventListener('mouseleave',function(){clearTimeout(t)});
    d.el.addEventListener('mouseenter',function(){clearTimeout(t)});
  });
  hdr.addEventListener('mouseleave',function(){if(hover.matches&&anyDrop()){clearTimeout(t);t=setTimeout(function(){panel(null)},180)}});
  $$('.sh-nav a').forEach(function(a){a.addEventListener('mouseenter',function(){if(hover.matches&&anyDrop())panel(null)})});
  scrim.addEventListener('click',function(){panel(null)});
  $$('[data-sh-search]').forEach(function(b){b.addEventListener('click',function(){searchBtn=b;panel(isOpen(search)?null:'search')})});

  var q=$('#ShQ'), res=$('#ShRes'), st=null, ctl=null;
  var esc=function(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML};
  q.addEventListener('input',function(){
    clearTimeout(st); var v=q.value.trim(), pop=$('#ShPop');
    if(pop)pop.hidden=v.length>=2;
    if(v.length<2){res.innerHTML='';return}
    st=setTimeout(function(){
      if(ctl)ctl.abort(); ctl=window.AbortController?new AbortController():null;
      fetch(root.dataset.suggest+'.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=5',ctl?{signal:ctl.signal}:{})
        .then(function(r){return r.json()}).then(function(d){
          var p=(d.resources&&d.resources.results&&d.resources.results.products)||[];
          res.innerHTML=p.map(function(x){return '<a href="'+x.url+'">'+(x.image?'<img src="'+x.image+(x.image.indexOf('?')>-1?'&':'?')+'width=120" alt="" loading="lazy">':'<i></i>')+'<b>'+esc(x.title)+'</b></a>'}).join('')
            +(p.length?'<a class="sh-sall" href="'+root.dataset.search+'?q='+encodeURIComponent(v)+'&options%5Bprefix%5D=last">'+esc(root.dataset.all)+'</a>':'<p class="sh-sall">'+esc(root.dataset.none)+'</p>');
        }).catch(function(){});
    },220);
  });

  function drawer(on){
    document.body.classList.toggle('sh-drawer-on',on);
    drawerEl.classList.toggle('is-show',on); dscrim.classList.toggle('is-show',on);
    drawerEl.setAttribute('aria-hidden',!on);
    $$('[data-sh-drawer]').forEach(function(b){b.setAttribute('aria-expanded',on)});
    document.documentElement.style.overflow=on?'hidden':'';
    if(on)panel(null);
  }
  /* body class while search is open, for the theme WhatsApp button (CSS also uses :has) */
  new MutationObserver(function(){document.body.classList.toggle('sh-search-on',isOpen(search))}).observe(search,{attributes:true,attributeFilter:['class']});
  $$('[data-sh-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer(true)})});
  dscrim.addEventListener('click',function(){drawer(false)});
  $$('[data-close]',drawerEl).forEach(function(a){a.addEventListener('click',function(){drawer(false)})});
  $$('[data-sh-acc]',drawerEl).forEach(function(b){b.addEventListener('click',function(){
    var sub=document.getElementById(b.getAttribute('aria-controls')), on=!sub.classList.contains('is-open');
    $$('[data-sh-acc]',drawerEl).forEach(function(o){if(o===b)return;var os=document.getElementById(o.getAttribute('aria-controls'));if(os)os.classList.remove('is-open');o.setAttribute('aria-expanded','false')});
    sub.classList.toggle('is-open',on); b.setAttribute('aria-expanded',on);
  })});
  if(desk.addEventListener)desk.addEventListener('change',function(e){if(e.matches)drawer(false);else panel(null)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){panel(null);drawer(false)}});
  document.addEventListener('click',function(e){if(!root.contains(e.target)&&(anyDrop()||isOpen(search)))panel(null)});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
